import dotenv from 'dotenv'
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { setContext } from '@apollo/client/link/context'

dotenv.config()

const storageItem = 'authContext-portal-analytics'
const httpLink = createHttpLink({
  uri: process.env.REACT_APP_APOLLO_SERVER_URL
})

const logoutLink = onError(({ networkError = {} as any }) => {
  const status: number = networkError && networkError.statusCode ? networkError.statusCode : null
  if ([401, 403].includes(status)) {
    sessionStorage.clear()
    localStorage.clear()
    window.location.replace('/')
  }
})

const authLink = setContext((_, { headers }) => {
  const localState = JSON.parse(localStorage.getItem(storageItem) || '{}')
  const token = localState.idToken
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: logoutLink.concat(authLink.concat(httpLink))
})

export default apolloClient
